export default __webpack_public_path__ + "static/media/847.aa183ab7.png";